import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getActiveDirectoryAuthToken } from "utils/getActiveDirectoryAuthToken";
import { v4 as uuidv4 } from "uuid";
import config from "../../config";

// Base RTK Query API setup for the DGCS Arbiter Auth service (RBAC roles & role assignments).
export const accessServiceApiSlice = createApi({
  reducerPath: "accessServiceApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${typeof config === "string" ? config : config.organization}/api/auth`,
    prepareHeaders: async (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("x-correlation-id", uuidv4());

      // TODO: remove once the Arbiter API no longer requires this header.
      if (process.env.REACT_APP_ARBITER_API_KEY) {
        headers.set("x-api-key", process.env.REACT_APP_ARBITER_API_KEY);
      }

      const authToken = await getActiveDirectoryAuthToken();
      headers.set("Authorization", `Bearer ${authToken}`);
      return headers;
    },
  }),
  tagTypes: ["Role", "RoleAssignment", "EffectiveAccess", "Permissions"],
  endpoints: () => ({}),
});
